import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const TemplateClassic = ({ data }) => {
  if (!data) return null;
  const rawInvoice = data.invoice || data.Invoice;
  if (!rawInvoice) return null;

  // Normalize Invoice object to support both camelCase and PascalCase
  const invoice = {
    id: rawInvoice.id || rawInvoice.Id,
    clientId: rawInvoice.clientId || rawInvoice.ClientId,
    templateId: rawInvoice.templateId || rawInvoice.TemplateId,
    invoiceNo: rawInvoice.invoiceNo || rawInvoice.InvoiceNo,
    invoiceDate: rawInvoice.invoiceDate || rawInvoice.InvoiceDate,
    billerGSTIN: rawInvoice.billerGSTIN || rawInvoice.BillerGSTIN || '',
    billerAddress: rawInvoice.billerAddress || rawInvoice.BillerAddress || '',
    billerContact: rawInvoice.billerContact || rawInvoice.BillerContact || '',
    billToCompany: rawInvoice.billToCompany || rawInvoice.BillToCompany || '',
    billToName: rawInvoice.billToName || rawInvoice.BillToName || '',
    billToAddress: rawInvoice.billToAddress || rawInvoice.BillToAddress || '',
    billToGSTIN: rawInvoice.billToGSTIN || rawInvoice.BillToGSTIN || '',
    billToEmail: rawInvoice.billToEmail || rawInvoice.BillToEmail || '',
    subTotal: rawInvoice.subTotal || rawInvoice.SubTotal || 0,
    totalCGST: rawInvoice.totalCGST || rawInvoice.TotalCGST || rawInvoice.totalCgst || rawInvoice.TotalCgst || 0,
    totalSGST: rawInvoice.totalSGST || rawInvoice.TotalSGST || rawInvoice.totalSgst || rawInvoice.TotalSgst || 0,
    grandTotal: rawInvoice.grandTotal || rawInvoice.GrandTotal || 0,
    paymentStatus: rawInvoice.paymentStatus || rawInvoice.PaymentStatus || 'Unpaid',
    templateComponent: rawInvoice.templateComponent || rawInvoice.TemplateComponent || '',
    billerCompany: rawInvoice.billerCompany || rawInvoice.BillerCompany || 'Intechronix',
    billerLogoUrl: rawInvoice.billerLogoUrl || rawInvoice.BillerLogoUrl || ''
  };

  const rawItems = data.items || data.Items || [];
  const items = rawItems.map(item => ({
    description: item.description || item.Description || '',
    hsnSacCode: item.hsnSacCode || item.HsnSacCode || '',
    qty: item.qty || item.Qty || 0,
    netPrice: item.netPrice || item.NetPrice || 0,
    gstPercentage: item.gstPercentage || item.GstPercentage || 0,
    cgstAmount: item.cgstAmount || item.CgstAmount || 0,
    sgstAmount: item.sgstAmount || item.SgstAmount || 0,
    totalItemPrice: item.totalItemPrice || item.TotalItemPrice || 0
  }));

  const status = invoice.paymentStatus.toUpperCase();
  const statusColor = status === 'PAID' ? 'green' : 'red';
  
  const seller = invoice.billerCompany;
  const invNo = invoice.invoiceNo;
  const billTo = invoice.billToCompany;
  const total = invoice.grandTotal.toFixed(2);
  const gst = invoice.billToGSTIN || 'N/A';
  const primaryColor = invoice.templateColor || '#000000';

  const qrData = `SELLER: ${seller}\nINV NO: ${invNo}\nBILL TO: ${billTo}\nGSTIN: ${gst}\nTOTAL: ₹${total}\nSTATUS: ${status}`;

  return (
    <div style={{ 
        fontFamily: 'serif', 
        padding: '10mm', 
        background: '#fff', 
        color: '#000', 
        border: '1px solid #000', 
        position: 'relative', 
        overflow: 'hidden', 
        width: '210mm', 
        height: '297mm', 
        margin: '0 auto', 
        boxSizing: 'border-box',
        fontSize: '11pt',
        lineHeight: '1.2'
    }}>
      {/* Watermark/Stamp */}
      <div style={{ 
        position: 'absolute', 
        top: '40%', 
        left: '50%', 
        transform: 'translate(-50%, -50%) rotate(-30deg)', 
        fontSize: '6rem', 
        fontWeight: 'bold', 
        color: statusColor, 
        opacity: 0.1, 
        letterSpacing: '8px', 
        zIndex: 0, 
        pointerEvents: 'none', 
        userSelect: 'none',
        border: `6px solid ${statusColor}`, 
        padding: '0.5rem 1.5rem' 
      }}>
        {status}
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', position: 'relative', zIndex: 1, borderBottom: `2px solid ${primaryColor}`, paddingBottom: '0.5rem' }}>
        <div>
          <h1 style={{ margin: 0, textTransform: 'uppercase', letterSpacing: '2px', fontSize: '1.8rem', color: primaryColor }}>Tax Invoice</h1>
          <div style={{ marginTop: '0.5rem' }}><strong>Invoice No:</strong> {invNo}</div>
          <div><strong>Date:</strong> {new Date(invoice.invoiceDate).toLocaleDateString()}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <img src={invoice.billerLogoUrl || invoice.BillerLogoUrl || "https://intechronix.com/images/logo.svg"} alt="Logo" style={{ height: '100px', marginBottom: '0rem' }} />
          <div style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{seller}</div>
          <div style={{ fontSize: '9pt', whiteSpace: 'pre-line' }}>{invoice.billerAddress}</div>
          <div style={{ fontSize: '10pt', fontWeight: 'bold' }}>GSTIN: {invoice.billerGSTIN}</div>
        </div>
      </div>

      <div style={{ borderBottom: `1px solid ${primaryColor}`, paddingBottom: '0.8rem', marginBottom: '1rem', display: 'flex', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
        <div style={{ width: '60%' }}>
          <strong style={{ fontSize: '10pt', textTransform: 'uppercase' }}>Billed To:</strong>
          <div style={{ marginTop: '0.3rem', fontWeight: 'bold', fontSize: '1.1rem' }}>{invoice.billToCompany}</div>
          {invoice.billToName && <div style={{ fontSize: '10pt' }}>Attn: {invoice.billToName}</div>}
          <div style={{ fontSize: '10pt', whiteSpace: 'pre-line' }}>{invoice.billToAddress}</div>
          <div style={{ fontSize: '10pt', fontWeight: 'bold', marginTop: '2px' }}>GSTIN: {invoice.billToGSTIN}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <QRCodeSVG value={qrData} size={85} />
        </div>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '1rem', position: 'relative', zIndex: 1, minHeight: '200px' }}>
        <thead>
          <tr style={{ backgroundColor: primaryColor, color: '#ffffff', borderTop: `2px solid ${primaryColor}`, borderBottom: `2px solid ${primaryColor}` }}>
            <th style={{ padding: '6px', textAlign: 'left', borderRight: '1px solid #ffffff', fontSize: '10pt' }}>Description</th>
            <th style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid #000', fontSize: '10pt', width: '80px' }}>HSN</th>
            <th style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid #000', fontSize: '10pt', width: '50px' }}>Qty</th>
            <th style={{ padding: '6px', textAlign: 'right', borderRight: '1px solid #000', fontSize: '10pt', width: '90px' }}>Rate</th>
            <th style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid #000', fontSize: '10pt', width: '60px' }}>GST</th>
            <th style={{ padding: '6px', textAlign: 'right', fontSize: '10pt', width: '100px' }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {items && items.map((item, i) => (
            <tr key={i} style={{ borderBottom: `1px solid ${primaryColor}` }}>
              <td style={{ padding: '6px', borderRight: '1px solid #000', fontSize: '10pt' }}>{item.description}</td>
              <td style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid #000', fontSize: '10pt' }}>{item.hsnSacCode}</td>
              <td style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid #000', fontSize: '10pt' }}>{item.qty}</td>
              <td style={{ padding: '6px', textAlign: 'right', borderRight: '1px solid #000', fontSize: '10pt' }}>₹{item.netPrice.toFixed(2)}</td>
              <td style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid #000', fontSize: '10pt' }}>{item.gstPercentage}%</td>
              <td style={{ padding: '6px', textAlign: 'right', fontSize: '10pt', fontWeight: 'bold' }}>₹{item.totalItemPrice.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.5rem', position: 'relative', zIndex: 1 }}>
        <table style={{ width: '280px', border: '1px solid #000', borderCollapse: 'collapse' }}>
          <tbody>
             <tr><td style={{ padding: '4px', border: '1px solid #000', fontSize: '10pt' }}>Sub Total:</td><td style={{ textAlign: 'right', padding: '4px', border: '1px solid #000', fontSize: '10pt' }}>₹{invoice.subTotal?.toFixed(2)}</td></tr>
             <tr><td style={{ padding: '4px', border: '1px solid #000', fontSize: '10pt' }}>Total CGST:</td><td style={{ textAlign: 'right', padding: '4px', border: '1px solid #000', fontSize: '10pt' }}>₹{invoice.totalCGST?.toFixed(2)}</td></tr>
             <tr><td style={{ padding: '4px', border: '1px solid #000', fontSize: '10pt' }}>Total SGST:</td><td style={{ textAlign: 'right', padding: '4px', border: '1px solid #000', fontSize: '10pt' }}>₹{invoice.totalSGST?.toFixed(2)}</td></tr>
             <tr style={{ backgroundColor: '#eeeeee' }}><td style={{ padding: '6px', border: '2px solid #000', fontWeight: 'bold' }}>Total amount:</td><td style={{ textAlign: 'right', padding: '6px', border: '2px solid #000', fontWeight: 'bold', fontSize: '1.1rem' }}>₹{invoice.grandTotal?.toFixed(2)}</td></tr>
          </tbody>
        </table>
      </div>
      
      {/* Footer */}
      <div style={{ marginTop: 'auto', position: 'relative', zIndex: 1 }}>
        <div style={{ fontSize: '9pt', borderTop: '1px solid #000', paddingTop: '8px' }}>
          <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Notes / Terms & Conditions:</div>
          <div style={{ color: '#333' }}>
            - Payment due within agreed time. | - GST as applicable. | - Subject to Gorakhpur jurisdiction.
          </div>
        </div>
        
        <div style={{ textAlign: 'center', marginTop: '12px', fontStyle: 'italic', fontSize: '8pt', color: '#555', borderTop: '1px dashed #000', paddingTop: '6px' }}>
          This is a computer-generated document and no physical signature is required.
        </div>
      </div>
    </div>
  );
};
export default TemplateClassic;
